import type { FieldDef } from '@packages/core';
import { PRECISION_CURRENCY } from '@packages/core';

import { inferDisplayDecimalPlaces, inferStorageDecimalPlaces } from './numericCanonical';

export interface EditPrecisionSpec {
  storagePrecision: number;
  displayPrecision: number;
  /** True when blur display rounds tighter than API storage allows. */
  needsCanonicalGuard: boolean;
}

/**
 * Resolves edit-form display vs API storage precision for a domain FieldDef.
 * Currency fields default to 2 dp on blur unless JSON sets an explicit displayPrecision.
 */
export function resolveEditPrecisions(
  def: Pick<FieldDef, 'schema' | 'displayPrecision' | 'displayFormat' | 'inputPrecision'> & { type?: string },
): EditPrecisionSpec {
  const storagePrecision = inferStorageDecimalPlaces(def);
  let displayPrecision = inferDisplayDecimalPlaces(def);
  const hasExplicitDisplayPrecision = def.displayPrecision != null;

  if (
    !hasExplicitDisplayPrecision
    && def.displayFormat === 'currency'
    && storagePrecision > PRECISION_CURRENCY
  ) {
    displayPrecision = Math.min(displayPrecision, PRECISION_CURRENCY);
  }

  return {
    storagePrecision,
    displayPrecision,
    needsCanonicalGuard: storagePrecision > displayPrecision,
  };
}
